import "./index.scss";
import "startbootstrap-sb-admin/dist/css/styles.css";
import "startbootstrap-sb-admin/dist/js/scripts.js";
import "@fortawesome/fontawesome-free/js/fontawesome.min.js";

//set active menu
const sideNav = document.getElementById('sidenavAccordion');
if (sideNav)
{
    var sideNavLinks = sideNav.getElementsByClassName('nav-link');
    Object.values(sideNavLinks).forEach(function(link) {
        const href = link.getAttribute('href');
        if(href === window.location.pathname) {
            link.classList.add('active');
        }
        //console.log(href);
    });
}

// appending bootstrap is-invalid, each time there is an input-validation-error class
const allInput = document.getElementsByTagName('input');
const allSelection = document.getElementsByTagName('select');

function AppendInputInvalidClass(elements)
{
    Array.prototype.forEach.call(elements, function (inputElem) {
        if (inputElem.classList.value.includes('input-validation-error')) {
            inputElem.classList.add('is-invalid');
        }
        //console.log(inputElem.classList);
    });
}
AppendInputInvalidClass(allInput);
AppendInputInvalidClass(allSelection);

// hide sidenav heading with no child items
var sideNavHeadings = document.getElementsByClassName('sb-sidenav-menu-heading');
Object.values(sideNavHeadings).forEach(function (sideNavHeading) {
    if (!sideNavHeading.nextElementSibling?.classList.value.includes('nav-link')) {
        sideNavHeading.classList.add('d-none');
    }
    //console.log(sideNavHeading);
});